(() => {
  if (window.whosifyProductV4Bound) return;
  window.whosifyProductV4Bound = true;

  const observers = new Map();
  let refreshQueued = false;
  const productInfos = () => document.querySelectorAll('.w-pdp-v4 [data-w-product-info]');
  const numericId = (value) => /^\d+$/.test(String(value || '')) ? String(value) : '';

  const selectedVariantId = (info, link) => {
    const form = document.forms.namedItem(info.dataset.productForm || '');
    const input = form && form.elements.namedItem('id');
    return numericId(input && input.value) || numericId(link.dataset.variantId);
  };

  const designUrl = (info, link) => {
    // The rendered anchor remains a working fallback without this script.
    const fallback = new URL(link.getAttribute('href'), window.location.href);
    if (fallback.origin !== window.location.origin) return null;
    let result = fallback;
    const override = window.zakekeUrl;
    if (typeof override === 'string' && override.trim()) {
      try {
        const proxy = new URL(override, window.location.origin);
        const root = new URL(link.dataset.rootUrl || '/', window.location.origin);
        if (proxy.origin === window.location.origin && root.origin === window.location.origin) {
          const prefix = root.pathname.replace(/\/$/, '');
          if (prefix && proxy.pathname !== prefix && !proxy.pathname.startsWith(`${prefix}/`)) {
            proxy.pathname = prefix + proxy.pathname;
          }
          result = proxy;
        }
      } catch (_) { /* Keep the rendered same-origin app URL. */ }
    }
    const productId = numericId(link.dataset.productId);
    const variantId = selectedVariantId(info, link);
    if (!productId) return null;
    result.searchParams.set('pid', productId);
    if (variantId) result.searchParams.set('id', variantId);
    else result.searchParams.delete('id');
    return result;
  };

  const syncInfo = (info) => {
    const language = document.documentElement.lang.toLowerCase().startsWith('zh') ? 'zh' : 'en';
    info.querySelectorAll('[data-w-lang]').forEach((element) => {
      element.hidden = element.dataset.wLang !== language;
    });
    info.querySelectorAll('a[data-w-design-card]').forEach((link) => {
      try {
        const url = designUrl(info, link);
        if (url) link.href = url.toString();
      } catch (_) { /* An invalid optional override must not break the page. */ }
    });
  };

  const refresh = () => {
    refreshQueued = false;
    observers.forEach((observer, root) => {
      if (!root.isConnected) { observer.disconnect(); observers.delete(root); }
    });
    document.querySelectorAll('.w-pdp-v4').forEach((root) => {
      if (observers.has(root)) return;
      const observer = new MutationObserver((records) => {
        if (records.some((record) => record.type === 'childList')) queueRefresh();
      });
      observer.observe(root, { childList: true, subtree: true });
      observers.set(root, observer);
    });
    productInfos().forEach(syncInfo);
  };

  const queueRefresh = () => {
    if (refreshQueued) return;
    refreshQueued = true;
    queueMicrotask(refresh);
  };

  const updatePrice = (info, variant) => {
    if (!variant || !Number.isFinite(variant.price)) return;
    const currency = info.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'HKD';
    let format;
    try {
      format = new Intl.NumberFormat(document.documentElement.lang || 'en-HK', { style: 'currency', currency });
    } catch (_) { return; }
    info.querySelectorAll('[data-w-product-price]').forEach((element) => {
      element.textContent = format.format(variant.price / 100);
    });
    info.querySelectorAll('[data-w-compare-price]').forEach((element) => {
      const show = Number.isFinite(variant.compare_at_price) && variant.compare_at_price > variant.price;
      element.hidden = !show;
      if (show) element.textContent = format.format(variant.compare_at_price / 100);
    });
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    const link = target && target.closest('.w-pdp-v4 a[data-w-design-card]');
    const info = link && link.closest('[data-w-product-info]');
    if (!info || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (link.hidden || link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
    let url;
    try { url = designUrl(info, link); } catch (_) { return; }
    if (!url) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(url.toString());
  });

  document.addEventListener('variant:change', (event) => {
    const detail = event.detail || {};
    const formId = typeof detail.formId === 'string' && detail.formId
      ? detail.formId
      : event.target && event.target.getAttribute && event.target.getAttribute('id');
    if (!formId) return;
    productInfos().forEach((info) => {
      if (info.dataset.productForm !== formId) return;
      const variant = detail.variant;
      const available = Boolean(variant && variant.available);
      info.querySelectorAll('a[data-w-design-card]').forEach((link) => {
        if (variant && numericId(variant.id)) link.dataset.variantId = String(variant.id);
        link.hidden = !available;
        if (available) { link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); }
        else { link.setAttribute('aria-disabled', 'true'); link.setAttribute('tabindex', '-1'); }
      });
      info.querySelectorAll('[data-w-design-sold-out]').forEach((element) => { element.hidden = available; });
      const originalForm = info.querySelector('[data-w-original-form]');
      if (originalForm) {
        const input = originalForm.elements.namedItem('id');
        if (input) {
          input.value = variant && numericId(variant.id) || '';
          input.disabled = !available;
        }
        originalForm.querySelectorAll('[data-w-original-card]').forEach((button) => { button.disabled = !available; });
      }
      updatePrice(info, variant);
      syncInfo(info);
    });
  });


  // The original-card option uses Shopify's native product form. It only adds
  // the selected card, with an explicit production marker, then opens the cart.
  // Keep this independent of Zakeke, including when its scripts fail to load.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.w-pdp-v4 [data-w-original-form]')) return;
    if (event.defaultPrevented) return;
    const input = form.elements.namedItem('id');
    if (!input || input.disabled || !numericId(input.value) || form.dataset.wSubmitting === 'true') {
      event.preventDefault();
      return;
    }
    form.dataset.wSubmitting = 'true';
    form.querySelectorAll('[data-w-original-card]').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });
  });

  window.addEventListener('pageshow', () => {
    productInfos().forEach((info) => {
      const form = info.querySelector('[data-w-original-form]');
      if (!form) return;
      delete form.dataset.wSubmitting;
      const input = form.elements.namedItem('id');
      form.querySelectorAll('[data-w-original-card]').forEach((button) => {
        button.disabled = !input || input.disabled || !numericId(input.value);
        button.removeAttribute('aria-busy');
      });
    });
  });

  // Impact replaces Liquid blocks during variant changes. Delegated clicks and
  // this scoped refresh keep newly rendered controls working in the editor too.
  document.addEventListener('product:rerender', queueRefresh, true);
  document.addEventListener('shopify:section:load', queueRefresh);
  document.addEventListener('shopify:section:unload', queueRefresh);
  const languageObserver = new MutationObserver(queueRefresh);
  languageObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();

